import { useEventListener } from '@vueuse/core'

export function useClickAway (
  target,
  listener,
  options = {}
) {
  const { eventName = 'click' } = options

  const onClick = (event) => {
    const targets = Array.isArray(target) ? target : [target]
    const isClickAway = targets.every((item) => {
      const element = unref(item)
      return element && !element.contains(event.target)
    })

    if (isClickAway) {
      listener(event)
    }
  }

  useEventListener(eventName, onClick, { target: document })
}
